class ProductVariantDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.buttonTrigger = this.buttonTrigger.bind(this)

    if (!this.els?.button?.exists) return

    this.els.button.elements.forEach(buttonEl => {
      this.listeners.add(buttonEl, 'click', this.buttonTrigger)
    })

    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.selectTrigger = this.selectTrigger.bind(this)

    this.listeners.add(this.optionChoicesEl, 'click', this.toggleDropdown)
    this.listeners.add(this.select, 'change', this.selectTrigger)
  }

  toggleDropdown () {
    this.containerEl?.setAttribute(
      'aria-expanded',
      this.expanded ? 'false' : 'true',
    )
    this.select?.focus()
  }

  buttonTrigger = event => {
    const variant = event.currentTarget.value
    const changeEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    })

    this.productFormIdEl.value = event.currentTarget.dataset.id
    this.select.value = variant
    this.select.dispatchEvent(changeEvent)

    this.closest('variant-select')?.setAttribute('aria-expanded', 'false')
  }

  selectTrigger = event => {
    const selectedOption = this.select.options[this.select.selectedIndex]
    const variantId = selectedOption.dataset.id

    if (!variantId) return

    this.productFormIdEl.value = variantId
    this.closest('variant-select')?.setAttribute('aria-expanded', 'false')
  }

  get productFormIdEl () {
    if (this.isQuickBuy) {
      return this.externalEls.quick_buy_form_id.element
    }

    return this.externalEls.product_form_id.element
  }

  get isQuickBuy () {
    return this.closest('quick-buy-modal') !== null
  }

  get select () {
    return this.closest(this.externalEls.container.selector).querySelector(
      'select[name="options[options]"]',
    )
  }

  get optionChoicesEl () {
    return this.containerEl?.querySelector(
      this.externalEls['option-choice'].selector,
    )
  }

  get containerEl () {
    return this.closest(this.externalEls.container.selector)
  }

  get expanded () {
    return (
      this.closest('variant-select')?.getAttribute('aria-expanded') === 'true'
    )
  }
}

if (!customElements.get('product-variant-dropdown')) {
  customElements.define('product-variant-dropdown', ProductVariantDropdown)
}
